import { render, staticRenderFns } from "./GetCustomerDetail.vue?vue&type=template&id=1168b143&scoped=true&"
import script from "./GetCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./GetCustomerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1168b143",
  null
  
)

export default component.exports